/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequest
 */
export interface JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequest {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequest
     */
    orderKey?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequest
     */
    customerNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequest
     */
    jepBookingId?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequest
     */
    idNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequest
     */
    courseId?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequest
     */
    companyCd?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequest
     */
    subscriptionId?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequest
     */
    priceDiv?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequest
     */
    dtlSts?: string;
}

export function JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequestFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequest {
    return JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequestFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orderKey': !exists(json, 'orderKey') ? undefined : json['orderKey'],
        'customerNo': !exists(json, 'customerNo') ? undefined : json['customerNo'],
        'jepBookingId': !exists(json, 'jepBookingId') ? undefined : json['jepBookingId'],
        'idNo': !exists(json, 'idNo') ? undefined : json['idNo'],
        'courseId': !exists(json, 'courseId') ? undefined : json['courseId'],
        'companyCd': !exists(json, 'companyCd') ? undefined : json['companyCd'],
        'subscriptionId': !exists(json, 'subscriptionId') ? undefined : json['subscriptionId'],
        'priceDiv': !exists(json, 'priceDiv') ? undefined : json['priceDiv'],
        'dtlSts': !exists(json, 'dtlSts') ? undefined : json['dtlSts'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequestToJSON(value?: JpCoBenefitoneBsdpBffPresentationRequestOrderConfirmNoPaymentPostRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'orderKey': value.orderKey,
        'customerNo': value.customerNo,
        'jepBookingId': value.jepBookingId,
        'idNo': value.idNo,
        'courseId': value.courseId,
        'companyCd': value.companyCd,
        'subscriptionId': value.subscriptionId,
        'priceDiv': value.priceDiv,
        'dtlSts': value.dtlSts,
    };
}

